"use client";
import { memo } from "react";

import { selectFilterOptions } from "@/feature/flight/search/state/selectors";
import { setFilters } from "@/feature/flight/search/state/slices/extract-flight-filter.slice";
import { useAppDispatch, useAppSelector } from "@/redux/hooks";

import { MultiSelector } from "@/feature/flight/search/components/shared/multi-selector";
import AccordionSection from "./accordion-section";

const FlightNumberFilter = memo(() => {
  const dispatch = useAppDispatch();
  const { selectOption, defaultOption } = useAppSelector(
    selectFilterOptions,
  );
  const isResponseEnd = useAppSelector(
    (state) => state.flightSearchStatus.isResponseEnd,
  );

  const flightNumbers = defaultOption?.flight_numbers || [];
  const selectedFlightNumbers = selectOption?.flight_number || [];

  const handleChange = (updatedNumbers: string[]) => {
    dispatch(setFilters({ flight_number: updatedNumbers }));
  };

  return (
    <AccordionSection value="flight-numbers" label="Flight Number">
      <MultiSelector
        disabled={!isResponseEnd}
        values={selectedFlightNumbers}
        onValuesChange={handleChange}
        options={flightNumbers}
        placeholder="Select flight numbers"
        className="w-full"
      />
    </AccordionSection>
  );
});

FlightNumberFilter.displayName = "FlightNumberFilter";
export default FlightNumberFilter;
